import { Box, Typography, Link, Card, CardContent, TextField, Button } from '@mui/material';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import LocationOnIcon from '@mui/icons-material/LocationOn';

const ContactUs = () => {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '100px 20px',
                gap: 4,
                backgroundColor: '#ffffff',
                minHeight: '100vh'

            }}
        >
            {/* Title */}
            <Typography
                variant="h3"
                fontWeight="bold"
                color="primary"
                sx={{
                    textTransform: 'uppercase',
                    letterSpacing: 1.5,
                    marginBottom: 2
                }}
            >
                Contact Us
            </Typography>

            {/* Contact Details */}
            <Card sx={{ width: '100%', maxWidth: 800, boxShadow: 3, borderRadius: 3 }}>
                <CardContent sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                    {/* Phone */}
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                        <PhoneIcon color="primary" />
                        <Typography variant="h6">
                            <Link
                                href="tel:+9722929277"
                                underline="hover"
                                sx={{ fontWeight: '500', color: '#007bff' }}
                            >
                                +1 (972) 292 9277
                            </Link>
                        </Typography>
                    </Box>

                    {/* Email */}
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                        <EmailIcon color="primary" />
                        <Typography variant="h6">
                            <Link
                                href="mailto:info@currieshub.com"
                                underline="hover"
                                sx={{ fontWeight: '500', color: '#007bff' }}
                            >
                                nagskitchentx@gmail.com
                            </Link>
                        </Typography>
                    </Box>

                    {/* Address */}
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                        <LocationOnIcon color="primary" />
                        <Typography variant="h6">
                            800 W eldorado Pkwy, 128, Little Elm, TX 75068
                        </Typography>
                    </Box>
                </CardContent>
            </Card>

            {/* Contact Form */}
            <Card sx={{ width: '100%', maxWidth: 800, boxShadow: 3, borderRadius: 3, padding: '20px' }}>
                <Typography variant="h5" fontWeight="bold" marginBottom={2}>
                    Get in Touch
                </Typography>
                <form>
                    <Box sx={{ display: 'flex', gap: 2, marginBottom: 2 }}>
                        <TextField
                            fullWidth
                            label="Your Name"
                            variant="outlined"
                            required
                        />
                        <TextField
                            fullWidth
                            label="Your Email"
                            type="email"
                            variant="outlined"
                            required
                        />
                    </Box>
                    <TextField
                        fullWidth
                        label="Subject"
                        variant="outlined"
                        margin="normal"
                        required
                    />
                    <TextField
                        fullWidth
                        label="Message"
                        multiline
                        rows={4}
                        variant="outlined"
                        margin="normal"
                        required
                    />
                    <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        sx={{
                            marginTop: 2,
                            padding: '12px',
                            fontSize: '16px',
                            fontWeight: 'bold',
                            width: '100%'
                        }}
                    >
                        Send Message
                    </Button>
                </form>
            </Card>


        </Box>
    );
};

export default ContactUs;
